import {stringify} from 'qs'
/** 
 * 通用promise 错误处理方案
 * @param { Promise } promise 函数
 * @param { Object= } errorExt 额外错误参数
 * @return { Promise } [函数结果, 错误内容]
 * https://github.com/scopsy/await-to-js/blob/master/src/await-to-js.ts
 */
export function to( promise: Promise<any>, errorExt?: object){
    return promise
      .then(data => [data, null])
      .catch(err => {
        return [undefined, {...err, ...errorExt}];
    });
}

// 通用接口配置
const reqCommon = async (url, config = {}) => {
  let _conf = {
    method: 'get',
    headers:{
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    params: {},
  }
  Object.assign(_conf, config)
  // 特异化处理请求地址到params中
  _conf.params.r = url
  // post请求可传入body或data的json对象
  if(_conf.method == 'post') _conf.body = stringify(config.body || config.data)
  const baseUri ='/api.php'
  const res = await useFetch(baseUri, _conf)
  return resolveResponse(res)
}
// 统一的get/post方案
export const req = {
  get: reqCommon.bind(this),
  post(url, config = {}) {
    config.method = 'post'
    return reqCommon.call(this, url, config)
  },
  download(){}
}
// 统一格式化响应
const resolveResponse = function({data, error}){
  let res = {
    code: data._rawValue?.retCode,
    msg: data._rawValue?.retMsg,
    data: data._rawValue?.data
  }
  Object.assign(res, data._rawValue)
  if(error && error.value) {
    res.code = error.value.statusCode
    res.msg = '网络异常！'
  }
  return res
}
// 统一处理返回值，默认有错弹窗提醒
export const handleResponse = function(res, autoResolve = true) {
  let result = res && res.code == '200'
  if(!result && autoResolve && res?.msg) {
    ElMessage.error(res.msg)
  }
  return result
}

// 全局动效
export const animateCSS = ($element, animation = 'fadeIn', prefix = 'animate__') =>
  new Promise((resolve, reject) => {
    if(!$element || !$element.classList) reject('需要传入dom！')
    const animationName = `${prefix}${animation}`;
    $element.classList.add(`${prefix}animated`, animationName);
    function handleAnimationEnd(event) {
      event.stopPropagation();
      $element.classList.remove(`${prefix}animated`, animationName);
      resolve('Animation ended');
    }
    $element.addEventListener('animationend', handleAnimationEnd, {once: true});
});

// 监听dom显示后，触发动效
// 统一的动效处理方案
export const visibleAnimation = function(selector, animateName){
  return onElementVisibility.bind(null, selector, animateName)
}
const onElementVisibility = function(selector, animateName, visible){
  if(visible) {
    let dom = document.querySelector(selector)
    animateCSS(dom, animateName)
  }
}
